/**
 * Single source for material content types — keep in sync with Materials tab and Add content in course outline.
 */
export const TRAINING_MATERIAL_CONTENT_TYPES = [
  { value: 'youtube', label: 'YouTube' },
  { value: 'udemy', label: 'Udemy' },
  { value: 'coursera', label: 'Coursera' },
  { value: 'wiki', label: 'Wiki' },
  { value: 'medium', label: 'Medium' },
  { value: 'article', label: 'Article' },
  { value: 'document', label: 'Document' },
  { value: 'pdf', label: 'PDF' },
  { value: 'video', label: 'Video (file or URL)' },
  { value: 'audio', label: 'Audio' },
  { value: 'podcast', label: 'Podcast' },
  { value: 'flashcard', label: 'Flashcards' },
  { value: 'ebook', label: 'E-Book' },
  { value: 'slides', label: 'Slides' },
  { value: 'github', label: 'GitHub' },
  { value: 'reference', label: 'Reference' },
  { value: 'url', label: 'URL / other link' }
];

/** Types that expect a primary URL or link (video may use upload instead). */
export const CONTENT_TYPES_NEEDING_URL = new Set([
  'youtube',
  'udemy',
  'coursera',
  'wiki',
  'medium',
  'article',
  'document',
  'pdf',
  'audio',
  'podcast',
  'flashcard',
  'ebook',
  'slides',
  'github',
  'reference',
  'url'
]);
